import dayjs from "dayjs";

/**
 * Formats an ISO 8601 (YYYY-MM-DD) date as H2's "Month D, YYYY" long form —
 * e.g. "2027-01-02" -> "January 2, 2027" (AC-10's "Renews <Month D, YYYY>",
 * AC-22's "before October 1, 2026", AC-23's "on January 2, 2027"). Shared
 * by screens 2, 7 and 8 so the one date format lives in one place rather
 * than three screens each re-deriving month names.
 *
 * Deliberately narrow: this is presentation only, over a date the renewal
 * data port already supplied — it performs no date arithmetic of its own
 * (AC-23: "never calculated by the portal").
 */
export function formatLongDate(isoDate: string): string {
  return dayjs(isoDate).format("MMMM D, YYYY");
}
